export default {"src":"/_next/static/media/dogBone_64.4d364488.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};